module.exports = __webpack_public_path__ + "src/assets/img/zoom_in.dc742c9c.svg";